import type { EngineFactEnvelope } from "../report/contracts";
import { detectFactConflicts } from "../synthesis/policy";
import { engineTitleVi } from "./engine-labels";
import type { VietnameseComparisonSection } from "./types";

const metadataFactKeys = new Set([
  "source",
  "calendar",
  "birthDate",
  "birthTime",
  "birthTimeConfidence",
]);

export function buildComparisonSection(
  envelopes: readonly EngineFactEnvelope[],
): VietnameseComparisonSection {
  const conflicts = detectFactConflicts(envelopes).filter(
    (conflict) => !metadataFactKeys.has(conflict.factKey),
  );

  if (conflicts.length === 0) {
    return Object.freeze({
      headingVi: "Ma trận đồng thuận và khác biệt",
      summaryVi:
        "Không có khóa dữ kiện trùng tên giữa các phương pháp — Bát Tự giữ ưu tiên khi phát sinh xung đột.",
      conflicts: Object.freeze([]),
    });
  }

  return Object.freeze({
    headingVi: "Ma trận đồng thuận và khác biệt",
    summaryVi:
      "Luật ưu tiên Bát Tự. Không suy diễn ngoài khóa dữ kiện trùng tên.",
    conflicts: Object.freeze(
      conflicts.map((conflict) =>
        Object.freeze({
          factKeyVi: conflict.factKey,
          preferredEngineVi: engineTitleVi[conflict.preferredEngine],
          notesVi: `Ưu tiên dữ kiện từ ${engineTitleVi[conflict.preferredEngine]} khi các phương pháp không đồng nhất.`,
        }),
      ),
    ),
  });
}
